import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel", "summary", "search", "option", "checkbox", "scopeRadio"]

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.handleOutsideClick)
    this.updateSummary()
    this.updateScope()
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.disabled()) return

    this.panelTarget.hidden = !this.panelTarget.hidden

    if (!this.panelTarget.hidden && this.hasSearchTarget) {
      this.searchTarget.focus()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
      this.buttonTarget.focus()
    }
  }

  toggleOption() {
    this.updateSummary()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()

    this.optionTargets.forEach((option) => {
      const label = (option.dataset.label || option.textContent || "").toLowerCase()
      option.hidden = query.length > 0 && !label.includes(query)
    })
  }

  updateScope() {
    const scope = this.scopeRadioTargets.find((radio) => radio.checked)?.value
    const disabled = scope === "all"

    this.buttonTarget.disabled = disabled
    this.buttonTarget.classList.toggle("is-disabled", disabled)
    this.close()
    this.updateSummary()
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  updateSummary() {
    if (this.disabled()) {
      this.summaryTarget.textContent = "Ignored when all companies is selected"
      return
    }

    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked)

    if (selected.length === 0) {
      this.summaryTarget.textContent = "Select companies"
      return
    }

    const labels = selected.slice(0, 3).map((checkbox) => checkbox.dataset.label)
    const remainder = selected.length - labels.length
    this.summaryTarget.textContent = remainder > 0 ? `${labels.join(", ")} +${remainder}` : labels.join(", ")
  }

  close() {
    this.panelTarget.hidden = true
  }

  disabled() {
    return this.buttonTarget.disabled
  }
}
